import { FC } from "react";
import { Link } from "react-router-dom";
import { useCalcPriceQuery } from "../api/queries/priceQueries";
import { mappingBookingState2RequestDTO } from "../mapping/mappingBookingState2RequestDTO";
import { useMoney } from "../hooks/useMoney";
import { useTranslation } from "react-i18next";

// Renders the total section
export const CardTotalRow: FC<{
  cartItems: BookingState[];
  onGoToCart?: () => void;
}> = ({
  cartItems,
  onGoToCart, // Function to navigate to the shopping cart page
}) => {
  const { t } = useTranslation();
  const { formatMoney } = useMoney();
  const bookingPrice = useCalcPriceQuery(
    cartItems.map((x) => mappingBookingState2RequestDTO(x)),
  );
  return (
    <div className="shadow-[0px 4px 4px 0px #0000004D] bottom-0 flex h-[5.5rem] w-full justify-between border-t border-[#DCDCDC] bg-white">
      <div className="items-center py-4 pl-[1.125rem] text-left">
        <p className="mb-2 text-sm font-normal text-[#232323]">
          {t("Subtotal ")}({cartItems.length} {t("items")})
        </p>

        <p className="font-bold sm:text-[1.125rem] sm:leading-[1.625rem]">
          {formatMoney(bookingPrice?.data?.beforeServiceFeeTotal)}
        </p>
      </div>
      <Link
        onClick={onGoToCart}
        to="/shopping-cart"
        className="w-[7.5rem] content-center bg-[#A8C6FF] text-center text-base font-semibold sm:h-auto sm:w-[10.625rem]"
      >
        {t("Go to cart")}
      </Link>
    </div>
  );
};
